import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import * as moment from 'moment';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { ActivatedRoute } from '@angular/router';
import { DateFormatPipe } from 'src/app/pipes/dateformat.pipe';
declare const toastr: any;
@Component({
	selector: 'app-tot-toa-data-filter',
	templateUrl: './tot-toa-data-filter.component.html',
	styleUrls: ['./tot-toa-data-filter.component.css'],
	providers: [DateFormatPipe]
})
export class TotToaDataFilterComponent implements OnInit, AfterViewInit {
	jobRoles = [];
	modelObj = {
		scheme: null,
		schemeLevel: null,
		schemeData: null,
		reqType: null,
		state: null,
		district: null,
		jobRole: '',
		batchStatus: null,
		batchStatusCode: null,
		aaStatus: '',
		myLinkStatus: '',
		allLinkStatus: '',
		batchType: "",
		newBatchType: '',
		newKeywordSearch: '',
		pmkvyType: null,
		centre: '',
		keyword: '',
		endDt: null,
		startDt: null,
		tabStatus: '',
		sector: null,
		userType: null,
		applicantId: '',
		applicantName: '',
		batchId: null,
		tcName: '',
		originationCategory: '',
		country: null,
		typeOfCertification: '',
		status: null,
		proctorId: '',
		phone: '',
		regStatus: ''
	};
	@Input() customFilter: any;
	@Input() filterLabel: any;
	@ViewChild('startDate') startDate: ElementRef;
	@ViewChild('endDate') endDate: ElementRef;
	@Output() searchFilters: EventEmitter<any> = new EventEmitter<any>();
	@Output() resetFilters: EventEmitter<any> = new EventEmitter<any>();
	@Output() batchFiltersData: EventEmitter<any> = new EventEmitter<any>();

	states: any;
	districts: any;
	stateCode: any;
	batchType: any = [];
	pmkvyType: any;
	batchStatus: any;
	batchStatusFilterData: any
	aaStatus: any;
	myLinkStatus: any;
	allLinkStatus: any
	userInfo: any;
	schemeType: any;
	programType: any;
	reqType: any;
	batchStatusList: any;
	userRole: string;
	disableJobRoles = true;
	disablePmkvyType = true;
	sector: any;
	isBatchIdInput: boolean;
	startDt: any
	endDt: any
	userType = [];
	originationCategory: any = [];
	country = [];
	isDisable = false;
	stateDisbale = false;
	isRequestStatus = false;
	sectorDisable = false;
	regStatus: any = "";

	countries: any;

	originationcategories = [
		{
			name: 'Indian National',
			value: 'domestic'
		},
		{
			name: 'NRI/Foreign Residents',
			value: 'international',
		}
	]

	Types = [
		{
			userName: 'Trainer',
			userValue: 'trainer'
		},
		{
			userName: 'Master Trainer',
			userValue: 'masterTrainer'
		},
		{
			userName: 'Assessor',
			userValue: 'assessor'
		},
		{
			userName: 'Master Assessor',
			userValue: 'masterAssessor'
		}
	]

	status = [
		'Pending',
		'Approved',
		'Rejected',
		'Sentback'
	]

	typeOfCertification = [
		{
			name: 'Basic',
			value: 'Basic'
		},
		{
			name: 'Advanced',
			value: 'Advanced'
		}
	]

	aaStatuses = [{
		name: 'Draft',
		value: 'draft'
	}, {
		name: 'Created',
		value: 'created'
	}, {
		name: 'Accepted',
		value: 'Accepted'
	}, {
		name: 'Pending for Approval',
		value: 'registrationCompleted'
	}, {
		name: 'Rejected',
		value: 'Rejected'
	}]

	myLinkStatuses = [{
		name: 'Linked',
		value: 'link'
	}, {
		name: 'Inactive',
		value: 'delink'
	},
	{
		name: 'Extended',
		value: 'extend'
	}
	]

	allLinkStatuses = [{
		name: 'Available to Link',
		value: 'available'
	}, {
		name: 'Not Available to Link',
		value: 'not available'
	}]
	pageType: any;


	constructor(
		private geographiesService: GeographiesService,
		private totBatchService: TotBatchService,
		private convert: DateFormatPipe,
		private _script: ScriptLoaderService,
		private currentUser: CurrentUserService,
		private sectorsService: SectorsService,
		private route: ActivatedRoute
	) {
	}

	ngOnInit() {
		this.route.params.subscribe(res => {
			this.pageType = res && res.type;
		})
		this.getCurrentUser();
		this.getCountries();
		this.getStates();
		this.getSector();
		this.getBatchTypes();
		this.getBatchStatus();
		this.getUserType();
		this.getoriginationcategorys();
		if (this.customFilter && this.customFilter['jobRoles']) {
			this.getJobRoles();
		}
		if (this.customFilter.isAdrashScheme) {
			this.modelObj.sector = String(this.userInfo.sector.id);
			this.sectorDisable = true
		}
	}

	ngAfterViewInit() {
		this._script.loadScripts('app-tot-toa-data-filter',
			['./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js',
				'assets/demo/default/custom/components/forms/widgets/bootstrap-select.js']);
	}

	getCurrentUser() {
		this.currentUser.getCurrentUser().subscribe(loggedInUser => {
			this.userInfo = loggedInUser;
			// console.log(this.userInfo);
		});
	}

	getCountries() {
		this.geographiesService.getCountries().subscribe(country => {
			console.log(country);
			this.countries = country;
		})
	}

	getJobRoles(name?) {
		if (name === 'show' || this.userInfo.role === 'SSC') {
			this.disableJobRoles = false;
		} else {
			this.disableJobRoles = true;
		}
		this.jobRoles = [];
		const sectorId = this.userInfo && this.userInfo.sector && this.userInfo.sector.id ? this.userInfo.sector.id : this.modelObj.sector;
		this.sectorsService.getJobRoles(sectorId).subscribe(res => {
			this.jobRoles = res.data;
		})
	}

	getSector() {
		this.sectorsService.getSectors().subscribe((sectors) => {
			this.sector = sectors;
		});
	}

	showSelected(ngmodel, userobj) {
		if (ngmodel && userobj) {
			return ngmodel.userName === userobj.userName;
		}
	}

	showSector(item, formControlValue): boolean {
		if (item && formControlValue) {
			return item == formControlValue;
		} else {
			return false;
		}
	}

	showCountry(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.countryId === formControlValue.countryCode) || (item.countryId === formControlValue.countryId) || (item.country === formControlValue.name));
		} else {
			return false;
		}
	}

	getStates() {
		this.states = [];
		this.geographiesService.getStates().subscribe(res => {
			if (res && res.states && res.states.length) {
				this.stateCode = res.countryCode;
				this.states = res.states;
			}
		}, err => {
			console.log(err);
		});
	}

	getDistricts() {
		this.districts = [];
		let stateCode = 0;
		this.states.filter(state => {
			if (state.code === this.modelObj.state) {
				stateCode = state.code
			}
		})
		this.geographiesService.getDistricts(stateCode).subscribe(dist => {
			if (dist && dist.districts && dist.districts.length) {
				this.districts = dist.districts;
			}
		}, error => {
			console.log(`Error while fetching districts : ${error}`);
		});
	}

	async getBatchTypes() {
		await this.totBatchService.getBatchStatus().subscribe(type => {
			if (this.batchType && this.batchType.length === 0) {
				if (type.all && type.all.batchType) {
					type.all.batchType.filter(batchTypes => {
						this.batchType.push(batchTypes.value)
					});
				}
			}
			this.pmkvyType = type.all.scheme[1].data
		});
	}

	getUserType() {
		if (this.userInfo.role === 'Trainer') {
			for (let i = 0; i < this.Types.length; i++) {
				if (this.Types[i].userValue === 'trainer' || this.Types[i].userValue === 'masterTrainer') {
					this.userType.push(this.Types[i]);
				}
			}
		} else if (this.userInfo.role === 'Assessor') {
			for (let i = 0; i < this.Types.length; i++) {
				if (this.Types[i].userValue === 'assessor' || this.Types[i].userValue === 'masterAssessor') {
					this.userType.push(this.Types[i]);
				}
			}
		} else if (this.userInfo.role === 'SSC') {
			this.userType = this.Types;
		}
	}

	getoriginationcategorys() {
		this.originationCategory = this.originationcategories
	}


	setUtcDate(date) {
		const splitEnd = date.split('/');
		const Day = Number(splitEnd[0]);
		const Month = Number(splitEnd[1]);
		const Year = Number(splitEnd[2]);
		const formatedDt = moment().date(Day).month(Month - 1).year(Year).format('YYYY-MM-DD');
		// const retDt = moment(formatedDt).startOf('day');
		return formatedDt;
	}

	getSelectedValue() {
		console.log(this.modelObj.batchStatus)
		this.batchStatus.filter(data => {
			if (data.id === this.modelObj.batchStatus) {
				this.modelObj.batchStatusCode = data
			}
		})
	}
	applyFilters() {
		const emitData = {};
		console.log(this.modelObj);
		if (this.modelObj['scheme'] && this.modelObj['scheme'] !== '') {
			if (this.modelObj.scheme.includes('level')) {
				const data = this.modelObj.scheme.split(' ');
				emitData['scheme'] = data[1]
				emitData['schemeType'] = data[2];
				if (data.length === 4) {
					emitData['schemeLevelBatchType'] = data[3] || '';
				}
			} else {
				emitData['scheme'] = this.modelObj['scheme'];
			}
			// if (this.modelObj.scheme['type'] === 'PMKVY') {
			// 	emitData['schemeType'] = this.modelObj['scheme']['subType'];
			// 	emitData['schemeLevelBatchType'] = this.modelObj['scheme']['schemeLevelBatchType'] || '';
			// }
			// emitData['scheme'] = this.modelObj['scheme']['type'];
		}
		if (this.modelObj['reqType'] && this.modelObj['reqType'] !== '') {
			emitData['reqType'] = this.modelObj['reqType'];
		}
		if (this.modelObj['batchStatus'] && this.modelObj['batchStatus'] !== '') {
			// if (this.customFilter['isAssessment']) {
			// 	emitData['batchStatus'] = this.modelObj['batchStatus']['id'];
			// }
			if (((this.userRole === 'SSC' || this.userRole === 'ssc') && (this.customFilter['listingType'] !== 'batchRequestTotToa'))
				|| this.customFilter['listingType'] === 'marksAssessment' || this.customFilter['listingType'] === 'offlineAssessment') {
				emitData['statusFilter'] = []
				emitData['statusFilter'].push(this.modelObj['batchStatusCode']['id']);
			} else {
				emitData['batchStatus'] = this.modelObj['batchStatusCode']['value'];
			}
			/* 	if (this.modelObj['batchStatus'] && this.modelObj['batchStatus']['payloadId']) {
				emitData['statusFilter'] = this.modelObj['batchStatus']['payloadId'];
			} else {
				emitData['statusFilter'] = this.modelObj['batchStatus']['id'];
			} 	*/
		}
		if (this.modelObj['aaStatus'] && this.modelObj['aaStatus'] !== '') {
			emitData['aaStatus'] = this.modelObj['aaStatus'];
		}
		if (this.modelObj['myLinkStatus'] && this.modelObj['myLinkStatus'] !== '') {
			emitData['myLinkStatus'] = this.modelObj['myLinkStatus'];
		}
		if (this.modelObj['allLinkStatus'] && this.modelObj['allLinkStatus'] !== '') {
			emitData['allLinkStatus'] = this.modelObj['allLinkStatus'];
		}
		if (this.modelObj['batchType'] && this.modelObj['batchType'] !== '') {
			emitData['batchType'] = this.modelObj['batchType'];
		}
		if (this.modelObj['newBatchType'] && this.modelObj['newBatchType'] !== '') {
			emitData['batchType'] = this.modelObj['newBatchType'];
		}
		if (this.modelObj['newKeywordSearch'] && this.modelObj['newKeywordSearch'] !== '') {
			emitData['keyword'] = this.modelObj['newKeywordSearch'];
		}
		if (this.modelObj['pmkvyType'] && this.modelObj['pmkvyType'] !== '') {
			emitData['schemeType'] = this.modelObj['pmkvyType'];
		}
		if (this.modelObj['centre'] && this.modelObj['centre'] !== '') {
			emitData['centre'] = this.modelObj['centre'];
		}
		if (this.modelObj['district'] && this.modelObj['district'] !== '') {
			emitData['district'] = this.modelObj['district'];
		}
		if (this.modelObj['jobRole'] && this.modelObj['jobRole'] !== '') {
			// console.log(this.modelObj['jobRole']);
			emitData['jobRole'] = this.modelObj['jobRole'];
		}
		if (this.modelObj['state'] && this.modelObj['state'] !== '') {
			emitData['state'] = this.modelObj['state'];
		}
		if (this.modelObj['regStatus'] && this.modelObj['regStatus'] !== '') {
			emitData['regStatus'] = this.modelObj['regStatus'];
		}
		if (this.modelObj['keyword'] && this.modelObj['keyword'] !== '') {
			emitData['keyword'] = this.modelObj['keyword'];
		}
		if (this.modelObj['userType'] && this.modelObj['userType'] !== '') {
			emitData['userType'] = this.modelObj['userType'];
		}
		if (this.modelObj['typeOfCertification'] && this.modelObj['typeOfCertification'] !== '') {
			emitData['typeOfCertification'] = this.modelObj['typeOfCertification'];
		}
		if (this.modelObj['originationCategory'] && this.modelObj['originationCategory'] !== '') {
			emitData['originationCategory'] = this.modelObj['originationCategory'];
		}
		if (this.modelObj['country'] && this.modelObj['country'] !== '') {
			emitData['country'] = this.modelObj['country'];
		}
		if (this.modelObj['sector'] && this.modelObj['sector'] !== '') {
			// console.log(this.modelObj['sector']);
			emitData['sector'] = this.modelObj['sector'];
		}
		if (this.modelObj['applicantId'] && this.modelObj['applicantId'] !== '') {
			emitData['applicantId'] = this.modelObj['applicantId'];
		}
		if (this.modelObj['batchId'] && this.modelObj['batchId'] !== '') {
			emitData['batchId'] = this.modelObj['batchId'];
		}
		if (this.modelObj['applicantName'] && this.modelObj['applicantName'] !== '') {
			emitData['applicantName'] = this.modelObj['applicantName'];
		}
		if (this.modelObj['proctorId'] && this.modelObj['proctorId'] !== '') {
			emitData['proctorId'] = this.modelObj['proctorId'];
		}
		if (this.modelObj['phone'] && this.modelObj['phone'] !== '') {
			emitData['phone'] = this.modelObj['phone'];
		}
		if (this.modelObj['tcName'] && this.modelObj['tcName'] !== '') {
			emitData['tcName'] = this.modelObj['tcName'];
		}
		if (this.modelObj['status'] && this.modelObj['status'] !== '') {
			emitData['status'] = this.modelObj['status'];
		}
		if (this.startDate && this.startDate.nativeElement && this.startDate.nativeElement.value) {
			emitData['startDate'] = this.convert.transform(this.startDate.nativeElement.value);
		}
		if (this.endDate && this.endDate.nativeElement && this.endDate.nativeElement.value) {
			emitData['endDate'] = this.convert.transform(this.endDate.nativeElement.value);
		}
		if (emitData['startDate'] && emitData['endDate']) {
			if (moment(emitData['startDate']).unix() > moment(emitData['endDate']).unix()) {
				toastr.error('Batch start date must be less than or equals to Batch end date !!');
				return;
			}
		}
		// this.getEmittedDataObjects()
		// if (this.customFilter['isAssessment'] && emitData['batchStatus']) {
		// 	emitData['assessmentStatus'] = emitData['batchStatus']
		// 	delete emitData['batchStatus'];
		// }
		// console.log(this.modelObj['jobRole']);
		// console.log(emitData);
		// console.log(this.customFilter);
		this.searchFilters.emit(emitData);
	}
	getEmittedDataObjects() {
		const filterArray = {
			'state': {},
			'sector': {},
			'batchStatus': {},
			'batchType': {},
			'scheme': {}
		}
		console.log('this.modelObj', this.modelObj, this.customFilter);
		if (this.customFilter.state) {
			this.states.filter(stateDate => {
				if (this.modelObj['state'] == stateDate.code) {
					// filterArray.state = stateDate
				}
			})
		}
		if (this.customFilter.sector) {
			this.sector.filter(sectorData => {
				if (this.modelObj['sector'] == sectorData.sectorID) {
					filterArray.sector = sectorData
				}
			})
		}
		if (this.customFilter.batchStatus) {
			this.batchStatus.filter(statusData => {
				if (this.modelObj['batchStatus']['id'] == statusData.id) {
					filterArray.batchStatus = statusData
				}
			})
		}
		if (this.customFilter.batchType) {
			this.batchType.filter(type => {
				if (this.modelObj['batchType'] == type) {
					// filterArray.batchType = type
				}
			})
		}
		return filterArray
	}
	reset(name?) {
		this.modelObj.state = null;
		this.modelObj.jobRole = '';
		this.modelObj.batchStatus = null;
		this.modelObj.batchStatusCode = null;
		this.modelObj.aaStatus = '';
		this.modelObj.myLinkStatus = '';
		this.modelObj.allLinkStatus = '';
		this.modelObj.batchType = '';
		this.modelObj.pmkvyType = '';
		this.modelObj.centre = '';
		this.modelObj.endDt = null;
		this.modelObj.startDt = null;
		this.modelObj.district = null;
		this.modelObj.newBatchType = '';
		this.modelObj.newKeywordSearch = '';
		this.modelObj.keyword = null;
		this.modelObj.scheme = null;
		this.modelObj.schemeData = null;
		this.modelObj.reqType = null;
		this.modelObj.tabStatus = '';
		this.modelObj.userType = null;
		this.modelObj.applicantId = null;
		this.modelObj.batchId = null;
		this.modelObj.applicantName = null;
		this.modelObj.tcName = '';
		this.modelObj.originationCategory = '';
		this.modelObj.typeOfCertification = '';
		this.modelObj.country = null;
		this.modelObj.status = '',
			this.isDisable = false;
		this.stateDisbale = false;
		this.disablePmkvyType = true;
		this.modelObj.proctorId = '';
		this.modelObj.regStatus = '';
		this.modelObj.phone = '';
		this.schemeType = [];
		this.districts = [];
		this.isBatchIdInput = false
		// console.log('customFilter', this.customFilter);
		if (name === 'show' || this.userInfo.role === 'SSC') {
			this.disableJobRoles = false;
		} else {
			this.disableJobRoles = true;
		}
		if (this.startDate && this.startDate.nativeElement && this.startDate.nativeElement.value) {
			this.startDate.nativeElement.value = null;
		}
		if (this.startDate && this.endDate.nativeElement && this.endDate.nativeElement.value) {
			this.endDate.nativeElement.value = null;
		}
		if (!this.customFilter.isAdrashScheme) {
			this.modelObj.sector = null;
		}
		this.resetFilters.emit();
		this.getBatchStatus();
	}

	changeBatchStatusDropDown(userRole, isAssessment?) {
		this.schemeType = [];
		this.batchStatus = [];
		const data = this.customFilter['tabStatus'];
		const listingType = this.customFilter['listingType']
		this.programType = this.batchStatusList && this.batchStatusList['all'] &&
			this.batchStatusList['all']['scheme'] ? this.batchStatusList['all']['scheme'] : [];
		this.programType.filter(type => {
			if (this.customFilter.isAdrashScheme) {
				if (type.model.level) {
					type.data.filter(subType => {
						if (subType.level && subType.type && subType.value === 'RPL') {
							subType.type.filter(cssmschemes => {
								this.schemeType.push({
									'model': 'level' + ' ' + type.model.id + ' ' + subType.id + ' ' + cssmschemes.id,
									'type': type.model.value + ' ' + subType.value + ' ' + cssmschemes.value,
									'subType': subType.value, 'schemeLevelBatchType': cssmschemes.value || ''
								})
							})
						}
					})
				}
			} else {
				if (type.model.level) {
					type.data.filter(subType => {
						if (subType.level && subType.type) {
							subType.type.filter(cssmschemes => {
								this.schemeType.push({
									'model': 'level' + ' ' + type.model.id + ' ' + subType.id + ' ' + cssmschemes.id,
									'type': type.model.value + ' ' + subType.value + ' ' + cssmschemes.value,
									'subType': subType.value, 'schemeLevelBatchType': cssmschemes.value || ''
								})
							})
						} else {
							this.schemeType.push({
								'model': 'level' + ' ' + type.model.id + ' ' + subType.id,
								'type': type.model.value + ' ' + subType.value,
								'subType': subType.value
							})
						}
					})
				} else {
					this.schemeType.push({ 'model': type.model.id, 'type': type.model.value })
				}
				// console.log('After id change', this.schemeType);
				//  else {
				// 	//  if (type.model.value === 'Utkarsh Bangla') or nonPmkvyStates
				// 	this.schemeType.push({ 'model': type.model.value, 'type': type.model.value })
				// }
			}
		})
		// console.log(this.schemeType, this.programType);
		const filterDataType = listingType && listingType === 'batchRequestNonTotToa' ||
			listingType === 'batchRequestNonTotToaCr' ? 'pmkvy' : 'tot';
		if (isAssessment) {
			console.log("marks assmt....", this.batchStatusList[userRole]['marksAssessment'])
			this.batchStatus = this.batchStatusList[userRole]['marksAssessment'][data]['status'].filter(batchStatus => {
				this.batchStatusFilterData = batchStatus
				console.log('value....', batchStatus.value)
				return batchStatus.value
			});
		} else if (this.customFilter.tabStatus !== undefined &&
			this.batchStatusList !== undefined && (userRole === 'SSC' || userRole === 'ssc')) {
			this.batchStatusFilterData = this.batchStatusList[userRole][listingType]
			// console.log('this.batchStatus', this.customFilter, this.batchStatusList, this.batchStatusList[userRole][listingType][data]['status']);
			this.batchStatusList[userRole][listingType][data]['status'].filter(batchStatus => {
				// if (listingType === 'batchRequestTotToa') {
				this.batchStatus.push(batchStatus)
				// } else {
				// 	batchStatus.clientStatus.filter(uiStatus => {
				// 		if (uiStatus.type === filterDataType) {
				// 			uiStatus['serverStatus'] = batchStatus.serverStatus
				// 			uiStatus['payloadId'] = batchStatus.id
				// 			this.batchStatus.push(uiStatus)
				// 			console.log(this.batchStatus);
				// 		}
				// 	})
				// }
			});
		} else if (listingType === 'offlineAssessment') {
			this.batchStatusFilterData = this.batchStatusList[userRole][listingType]
			this.batchStatusList[userRole][listingType][data]['status'].filter(batchStatus => {
				this.batchStatus.push(batchStatus)
			});
		} else if (this.customFilter.tabStatus && this.customFilter.tabStatus !== 'cancelled' && this.batchStatusList !== undefined &&
			(userRole !== 'SSC' && userRole !== 'ssc')) {
			this.batchStatus = this.batchStatusList[userRole]['batchRequest'] && this.batchStatusList[userRole]['batchRequest'][data] && this.batchStatusList[userRole]['batchRequest'][data]['status'].filter(batchStatus => {
				this.batchStatusFilterData = batchStatus
				return batchStatus.value
			});
		}

		if (this.pageType === 'offlineAssessment') {
			this.batchStatus = [];
			this.batchStatusFilterData = this.batchStatusList[userRole]['offlineAssessment']
			this.batchStatusList[userRole]['offlineAssessment'][data]['status'].filter(batchStatus => {
				this.batchStatus.push(batchStatus)
			});
		}
		this.batchFiltersData.emit(this.batchStatusList[userRole])
		// console.log('changeStatus values', this.schemeType, this.batchStatusList, this.batchStatus, this.reqType);
	}
	async getBatchStatus() {
		const status = 'general';
		await this.totBatchService.getBatchStatus(status).subscribe(res => {
			// console.log(this.userInfo['role'], this.customFilter['isAssessment']);
			this.batchStatusList = res;
			if (this.userInfo && this.userInfo['role'] && this.userInfo['role'] === 'SSC') {
				if (this.customFilter['isAssessment']) {
					this.userRole = 'ssc';
					// console.log(this.customFilter['isAssessment']);
					this.changeBatchStatusDropDown(this.userRole, this.customFilter['isAssessment']);
				} else {
					if (res) {
						// console.log('Assessor General ds');
						this.userRole = 'ssc';
						// console.log(this.customFilter['isAssessment']);
						this.changeBatchStatusDropDown(this.userRole);
					} else {
						this.batchStatus = [];
					}
				}

			} else if (this.userInfo && this.userInfo['role'] && this.userInfo['role'] === 'Assessment Agency') {
				if (this.customFilter['isAssessment']) {
					this.userRole = 'assessmentAgency';
					// console.log(this.customFilter['isAssessment']);
					this.changeBatchStatusDropDown(this.userRole, this.customFilter['isAssessment']);
				} else {
					if (res) {
						// console.log('Assessor General ds');
						this.userRole = 'assessmentAgency';
						// console.log(this.customFilter['isAssessment']);
						this.changeBatchStatusDropDown(this.userRole);
					} else {
						this.batchStatus = [];
					}
				}
			} else if (this.userInfo && this.userInfo['role'] && this.userInfo['role'] === 'Assessor') {
				// console.log(this.customFilter['isAssessment']);
				if (this.customFilter['isAssessment']) {
					this.userRole = 'assessor';
					// console.log(this.customFilter['isAssessment']);
					this.changeBatchStatusDropDown(this.userRole, this.customFilter['isAssessment']);
				} else {
					if (res) {
						// console.log('Assessor General ds');
						this.userRole = 'assessor';
						// console.log(this.customFilter['isAssessment']);
						this.changeBatchStatusDropDown(this.userRole);
					} else {
						this.batchStatus = [];
					}
				}
			} else if (this.userInfo['role'] === 'Training Centre') {
				this.userRole = 'trainingCenter';
				// console.log(this.customFilter['isAssessment']);
				this.changeBatchStatusDropDown(this.userRole);
			} else {
				// console.log(this.customFilter['isAssessment']);
				this.changeBatchStatusDropDown(this.userInfo['role'].toLowerCase());
			}
		})
	}
	getSchemeType() {
		console.log('this.modelObj', this.modelObj);
		if (this.modelObj.scheme['type'] === 'PMKVY') {
			this.disablePmkvyType = false;
		} else {
			this.disablePmkvyType = true;
		}
	}

	isTyping(string) {
		if (string.length > 0) {
			this.modelObj.newBatchType = null;
			this.isBatchIdInput = true;
		} else if (string.length === 0) {
			this.isBatchIdInput = false;
		}
	}
	isBatchTypeSelected() {
		if (this.modelObj.newBatchType !== '') {
			this.isBatchIdInput = false;
		} else {
			this.isBatchIdInput = true;
		}
	}

	isRequestStatusSelected() {
		if (this.modelObj.status !== '') {
			this.isRequestStatus = false;
		} else {
			this.isRequestStatus = true;
		}
	}

	selectedCountry() {
		console.log(this.modelObj.originationCategory)
		if (this.modelObj.originationCategory === 'domestic') {
			const defaultValue = {
				code: 91,
				country: 'India',
				countryId: 'IN'
			}
			this.modelObj.country = defaultValue;
			this.countries.push(defaultValue);
			this.isDisable = true
			this.stateDisbale = false;
		} else {
			this.modelObj.country = null;
			this.isDisable = false;
			this.stateDisbale = true;
		}
	}
}
